import { IkasCountry } from "./index";
import { IkasLocationTranslations } from "./location-translations";

export function initIkasCountry(country: IkasCountry, locale: string | null) {
  if (country.locationTranslations && locale) {
    setTranslations(country, locale);
    delete country.locationTranslations;
  }
}

function setTranslations(country: IkasCountry, locale: string) {
  country.name =
    (country.locationTranslations &&
      country.locationTranslations[locale as keyof IkasLocationTranslations]) ||
    country.name;
}
